import { getSolarRecommand } from '@/service/solar-calculator';
import { getWSSUrl } from '@/utils/countryRegion';
import wss from '@/utils/mqtt-client';
import topics from '@/utils/mqtt-client/crowd-funding-topics';
import { useGlobal } from '@/utils/useGlobal';
import { EcoBundleEarlyBirdItemProps, EcoBundleIDGroupProps } from 'eco-design/sections/eco-bundle-early-bird/type';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
interface PathcDataType extends EcoBundleIDGroupProps {
    inventoryQuantity?: number;
    price?: number;
    compareAtPrice?: number;
    title?: string;
    pc?: string;
    isOnSale?: boolean;
}

const useWssEarlyBird = (activityId: number, bundles: EcoBundleEarlyBirdItemProps[]) => {
    const { getSystemTime } = useGlobal();
    const subscribes = ['inventory'];
    const { locale = 'us', query } = useRouter();
    const url = String(getWSSUrl(locale));
    const [init, setInit] = useState(false);
    const [initData, setInitData] = useState<boolean>(false);
    const [items, setItems] = useState([]); // 用于展示的产品组
    const [allPatchData, setAllPatchData] = useState<PathcDataType[]>([]); // 所有产品的所有信息（API数据+ID数据）
    const [allCurIdx, setAllCurIdx] = useState<number[]>([]); // 所有产品的当前索引组id // 仅针对有ids的产品组

    const { receiver, mqttSubscribe, mqttUnsubscribe } = wss({
        url,
        topics,
        locale,
        subscribes,
        activityId,
    });

    const handdleItemsUpdate = (allPatchData: PathcDataType[], allCurIdx: number[]) => {
        const newItems = JSON.parse(JSON.stringify(bundles || []));
        newItems?.map((item: EcoBundleEarlyBirdItemProps, k: number) => {
            if (item?.productId && item?.variantId && !item?.ids) {
                const targetPatchData = allPatchData?.find((data: PathcDataType) => data?.productId === item?.productId && data?.variantId === item?.variantId);
                if (targetPatchData) {
                    item = { ...item, ...targetPatchData };
                }
            } else {
                if (Array.isArray(item?.ids) && item?.ids?.length > 0) {
                    item.ids?.map((id: EcoBundleIDGroupProps, m: number) => {
                        if (id.productId && id.variantId && allCurIdx[k] === m) {
                            const targetPatchData = allPatchData?.find(
                                (data: PathcDataType) => data?.productId === id?.productId && data?.variantId === id?.variantId,
                            );
                            if (targetPatchData) {
                                const targetBundle = bundles[k];
                                const targetIdx = allCurIdx[k];
                                if (targetBundle && targetIdx >= 0 && Array.isArray(targetBundle?.ids)) {
                                    newItems[k] = {
                                        ...targetBundle,
                                        ...targetPatchData,
                                        tag: targetBundle.ids[targetIdx]?.tag || undefined,
                                        type: targetBundle.ids[targetIdx]?.type || undefined,
                                        countdown: targetBundle.ids[targetIdx]?.countdown || undefined,
                                        isOnSale: targetBundle.ids[targetIdx]?.isOnSale,
                                    };
                                }
                                return;
                            }
                        }
                    });
                }
            }
        });
        setItems(newItems);
    };

    const patchDataFromAPI = (newAllPatchData: PathcDataType[], api: any, item: EcoBundleEarlyBirdItemProps, id?: EcoBundleIDGroupProps) => {
        if (api) {
            if (!api?.productId) api.productId = item.productId;
            if (!api?.variantId) api.variantId = item.variantId;
            let existedItem = newAllPatchData?.find((data: PathcDataType) => data?.productId === api?.productId && data?.variantId === api?.variantId);
            if (existedItem) {
                existedItem.inventoryQuantity = Math.max(Number(api?.inventoryQuantity), 0);
                if (existedItem?.type === 'inventory') {
                    // 如果出现总库存比剩余库存还小，则总库存更新为剩余库存，以确保 {num} Backer 进度条显示时已购数量不为负数！
                    if (Number(existedItem?.totalInventoryQuantity) < api?.inventoryQuantity) {
                        existedItem.totalInventoryQuantity = api?.inventoryQuantity;
                    }
                }
                if (id) {
                    existedItem = { ...existedItem, ...id };
                }
            } else {
                const item: PathcDataType = {};
                item.title = api?.skuTitle || api?.productTitle;
                item.price = api?.price;
                item.compareAtPrice = api?.compareAtPrice || api?.price;
                item.variantId = api?.variantId;
                item.productId = api?.productId;
                item.inventoryQuantity = Math.max(Number(api?.inventoryQuantity), 0);
                if (item?.type === 'inventory') {
                    // 如果出现总库存比剩余库存还小，则总库存更新为剩余库存，以确保 {num} Backer 进度条显示时已购数量不为负数！
                    if (Number(item?.totalInventoryQuantity) < api?.inventoryQuantity) {
                        item.totalInventoryQuantity = api?.inventoryQuantity;
                    }
                }
                if (!item?.pc) {
                    item.pc = api?.variantImg || api?.img;
                }
                if (id) {
                    newAllPatchData.push({ ...item, ...id });
                } else {
                    newAllPatchData.push(item);
                }
            }
        }
    };

    const initPatchData = (result: any[], isMqtt?: boolean) => {
        const bunldes = JSON.parse(JSON.stringify(bundles || []));
        const newAllPatchData: any[] = isMqtt ? JSON.parse(JSON.stringify(allPatchData || [])) : [];
        bunldes?.map((item: EcoBundleEarlyBirdItemProps) => {
            if (item?.productId && item?.variantId && !item?.ids) {
                const api = result?.find((res: any) => res?.productId === item?.productId && res?.variantId === item?.variantId);
                if (api) {
                    patchDataFromAPI(newAllPatchData, api, item);
                }
            } else if (Number(item?.ids?.length) > 0) {
                item?.ids?.map((id: EcoBundleIDGroupProps) => {
                    if (id?.productId && id?.variantId) {
                        const api = result?.find((res: any) => res?.productId === id?.productId && res?.variantId === id?.variantId);
                        if (api) {
                            patchDataFromAPI(newAllPatchData, api, item, id);
                        }
                    }
                });
            }
        });
        setAllPatchData(newAllPatchData);
        setInitData(true);
    };

    const initAllCurIdx = () => {
        if (init && initData && allPatchData?.length > 0) {
            const newAllCurIdx: number[] = new Array(bundles?.length).fill(0);
            bundles?.forEach((bundle: EcoBundleEarlyBirdItemProps, k: number) => {
                if (Array.isArray(bundle?.ids) && bundle?.ids?.length > 0) {
                    for (let m = 0; m < bundle?.ids?.length; m++) {
                        const id = bundle?.ids[m];
                        if (id?.productId && id?.variantId) {
                            const target = allPatchData?.find((item: PathcDataType) => item?.productId === id?.productId && item?.variantId === id?.variantId);
                            if (target) {
                                if (
                                    target?.type === 'countdown' &&
                                    target?.countdown &&
                                    new Date(`${target?.countdown} GMT+8`).getTime() >
                                        (query?._timer ? new Date(`${query?._timer} GMT+8`).getTime() : getSystemTime())
                                ) {
                                    newAllCurIdx[k] = m;
                                    break;
                                } else if (
                                    target?.type === 'inventory' &&
                                    Number(target?.totalInventoryQuantity) > 0 &&
                                    Number(target?.inventoryQuantity) > 0
                                ) {
                                    newAllCurIdx[k] = m;
                                    break;
                                } else if (m === Number(bundle?.ids?.length) - 1) {
                                    newAllCurIdx[k] = m;
                                    break;
                                }
                            }
                        }
                    }
                }
            });
            setAllCurIdx(newAllCurIdx);
        }
    };

    const onCountdownEnd = (_: EcoBundleEarlyBirdItemProps) => {
        initAllCurIdx();
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const tempArr = JSON.parse(JSON.stringify(bundles || []));
            const result: any = [];
            const getAsynItem = async (productId: string, variantId: string) => {
                return await new Promise(async (resolve, reject) => {
                    try {
                        const res = await getSolarRecommand({ productId, variantId }, locale);
                        if (res?.code === '0') {
                            result.push({
                                productId,
                                variantId,
                                inventoryQuantity: res?.data?.inventoryQuantity || 0,
                                price: res?.data?.price ?? -1,
                                compareAtPrice: res?.data?.compareAtPrice ?? res?.data?.price ?? -1,
                                skuTitle: res?.data?.skuTitle || res?.data?.productTitle || '',
                                variantImg: res?.data?.variantImg || res?.data?.img || '',
                            });
                            return resolve(res);
                        } else {
                            console.error(res?.message);
                            return reject(res?.message);
                        }
                    } catch (e) {
                        console.error(e);
                        return reject(e);
                    }
                });
            };
            const promises: any[] = [];
            tempArr?.map((item: EcoBundleEarlyBirdItemProps) => {
                if (item?.productId && item.variantId) {
                    promises.push(getAsynItem(item?.productId, item.variantId));
                } else if (Number(item?.ids?.length) > 0) {
                    item?.ids?.map((id: EcoBundleIDGroupProps) => {
                        if (id.productId && id.variantId) {
                            promises.push(getAsynItem(id.productId, id.variantId));
                        }
                    });
                }
            });

            Promise.all(promises)
                .then(() => {
                    initPatchData(result);
                    setInit(true);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, []);

    useEffect(() => {
        initAllCurIdx();
    }, [init, initData, allPatchData, query?._timer]);

    useEffect(() => {
        if (init) {
            const { data } = receiver;
            if (data?.length > 0) {
                initPatchData(data, true);
            }
        }
    }, [receiver, init]);

    useEffect(() => {
        if (typeof window !== 'undefined' && init) {
            mqttSubscribe('inventory');
            return () => {
                mqttUnsubscribe('inventory');
            };
        }
    }, [init]);

    useEffect(() => {
        handdleItemsUpdate(allPatchData, allCurIdx);
    }, [allCurIdx, allPatchData]);

    return {
        items,
        onCountdownEnd,
    };
};

export default useWssEarlyBird;
